export const primaryFont = "Roboto, sans-serif";
